import { FormDto } from "api"

interface FileObject {
  fileName: string
  fileContents: File
}

const convertFilesToObject = (files: File | File[], filenames: string[]) => {
  const fileArray = Array.isArray(files) ? files : [files]
  const filesResponse: FileObject[] = []

  fileArray.map((file: File, index: number) => {
    const fileName = filenames[index]
    filesResponse.push({ fileName, fileContents: file })
  })
  return filesResponse
}

const convertFormData = (formData: any, formDto: FormDto) => {
  const convertedData: any = { values: {} }
  formDto.pages.forEach((page) => {
    page.fieldsets.forEach((fieldset) => {
      fieldset.columns.forEach((column) => {
        column.fields.forEach(async (field) => {
          const { alias } = field

          // Check for both original field ID and modified field name (for idNumber alias)
          const fieldKey =
            field.alias === "idNumber" ? `${field.id}_idNumber` : field.id
          const fieldValue = formData[fieldKey]

          if (alias && fieldValue !== undefined) {
            if (field.type.supportsUploadTypes) {
              const filenames = formData[`${field.id}_filenames`] || []
              convertedData.values[alias] = convertFilesToObject(
                fieldValue,
                filenames,
              )
            } else if (field.type.name === "Recaptcha2") {
              convertedData.values["g-recaptcha-response"] = fieldValue
              convertedData["g-recaptcha-response"] = fieldValue
            } else if (
              field.type.name === "Checkbox" ||
              field?.type?.name === "Checkbox with Rich Text"
            ) {
              // Convert boolean checkbox values to "true"/"false" strings
              const stringValue = fieldValue === true ? "true" : "false"
              convertedData.values[alias] = [stringValue]
            } else {
              convertedData.values[alias] = Array.isArray(fieldValue)
                ? fieldValue
                : [fieldValue]
            }
          }
        })
      })
    })
  })

  // Keep gRecaptchaResponse value without converting it
  if (formData.gRecaptchaResponse) {
    convertedData.gRecaptchaResponse = formData.gRecaptchaResponse
  }
  return convertedData
}

export default convertFormData
